import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PipelineSchedule } from '@/console/features/pipelines/components/pipeline-schedule/pipeline-schedule';
import { TypographyWithIcon } from '@/console/features/pipelines/components/pipeline-trigger-type/pipeline-trigger-type.styled';
import { TPipelineTriggerTypeProps } from '@/console/features/pipelines/components/pipeline-trigger-type/pipeline-trigger-type.types';
import { DotIcon } from '@/shared/assets/icons/dot-icon';
import { PipelineTriggerSourceTypeEnum } from '@/shared/types/types.generated';

export const PipelineTriggerType: React.FC<TPipelineTriggerTypeProps> = ({
  trigger,
  ...props
}) => {
  const { t } = useTranslation();

  const expression = 'expression' in trigger ? trigger.expression : undefined;
  const timezone =
    'expressionTimezone' in trigger ? trigger.expressionTimezone : undefined;

  if (trigger.type === PipelineTriggerSourceTypeEnum.Manual || !expression) {
    return (
      <Typography {...props}>
        {t(`pipelines:trigger_type_${trigger.type.toLowerCase()}`)}
      </Typography>
    );
  }

  return (
    <Stack direction="row" alignItems="center" flexWrap="nowrap">
      <TypographyWithIcon {...props}>
        {t(`pipelines:trigger_type_${trigger.type.toLowerCase()}`)}
        <DotIcon />
      </TypographyWithIcon>
      <PipelineSchedule
        expression={expression}
        timezone={timezone}
        {...props}
      />
    </Stack>
  );
};
